import { isTypeProgramsSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulProgramsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeProgramsSection(entry)) {
    return null;
  }

  return <div>ContentfulProgramsSection</div>;
};

export default ContentfulProgramsSection;
